import React from 'react';
import { connect } from 'react-redux';
import { fetchParentDocument, createParentDocument, updateParentDocument } from './actions';
import ParentDocumentSettingsForm from './SettingsForm';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

const Details = ({ match, history, parentId, parentDocument, genderTypes, createParentDocument, updateParentDocument, t }) => {
	const handleParentDocumentSettingsSubmit = (values) => {
		Object.assign(values, { parentId });
		if (parentDocument) {
			updateParentDocument(parentDocument.id, values);
		} else {
			createParentDocument(values, history);
		}
	};

	return <Panel>
		<Panel.Heading>{t('Common_Details')}</Panel.Heading>
		<Panel.Body>
			<ParentDocumentSettingsForm parentId={parentId} onSubmit={handleParentDocumentSettingsSubmit} initialValues={parentDocument} />
		</Panel.Body>
	</Panel>;
};

const mapStateToProps = (state, ownProps) => {
	const parentDocumentId = ownProps.match.params.parentDocumentId;

	const {
		entities: { parentDocuments }
	} = state;

	return {
		parentDocument: parentDocuments[parentDocumentId]
	};
};

export default connect(mapStateToProps, {
	createParentDocument,
	updateParentDocument
})(withTranslation()(Details));